import { useMemo } from "react";
import { UsersModel } from "../../../api";
import FilterableSelect from "../../basic/FilterableSelect";
import { useClioUsers } from "./useClioUsers";

const ROLE_OPTIONS = [
  { value: "RAA", label: "RAA" },
  { value: "AP", label: "AP" },
  { value: "ALA", label: "ALA" },
] as const;

type ClioTaskAssigneeSelectProps = {
  value?: string | null;
  onChange: (value: string) => void;
  label?: string;
  users?: UsersModel[];
  removeDisabled?: boolean;
  includeNone?: boolean;
  fullWidth?: boolean;
  required?: boolean;
};

/**
 * Assignee select for Clio task templates: role tokens (RAA/AP/ALA) plus Clio users by name.
 */
export default function ClioTaskAssigneeSelect({
  value,
  onChange,
  label = "Assignee",
  users: usersProp,
  removeDisabled = true,
  includeNone = true,
  fullWidth = true,
  required = false,
}: ClioTaskAssigneeSelectProps) {
  const { users: loadedUsers } = useClioUsers(removeDisabled, usersProp == null);
  const users = usersProp ?? loadedUsers;

  const options = useMemo(
    () => [
      ...ROLE_OPTIONS,
      ...users
        .filter((user) => Boolean(user.name?.trim()))
        .map((user) => ({
          value: user.name!,
          label: user.name!,
        })),
    ],
    [users]
  );

  return (
    <FilterableSelect
      label={label}
      fullWidth={fullWidth}
      required={required}
      includeAll={includeNone}
      includeNone={false}
      allOptionLabel="None"
      allOptionValue=""
      value={value ?? ""}
      options={options}
      onChange={(next) => onChange(next == null ? "" : String(next))}
    />
  );
}
